import React, { useEffect, useState } from "react";

const SLIDES = [
  {
    image: "/assets/homescreen/producttourimage-1.png",
    title: "Million2Trillion — Your Central Market Dashboard",
    points: [
      "Access verified professionals, investors, and businesses in one ecosystem",
      "Manage your posts, videos, and business content from a single dashboard",
      "Switch roles or profiles instantly with SmartCard login",
      "Track KYC, engagement, and growth from your central market hub",
    ],
  },
  {
    image: "/assets/homescreen/producttourimage-2.png",
    title: "Global Trading & Investment Command Center",
    points: [
      "Trade across markets and brokers from one screen",
      "Access real-time data, AI insights, and expert videos",
      "Copy top traders and track alerts in one live view",
      "Manage your portfolio and groups with 24/7 AI support",
    ],
  },
  {
    image: "/assets/homescreen/producttourimage-4.png",
    title: "The New Era of Broker Recognition",
    points: [
      "Showcase your brand with verified trust badges and rankings",
      "Get instant verified leads and promote multiple products",
      "Integrate APIs and analytics directly into the M2T network",
      "Gain visibility through global recognition and performance badges",
    ],
  },
  {
    image: "/assets/homescreen/producttourimage-3.png",
    title: "Top Traders & Verified Global Community",
    points: [
      "Join verified traders, investors, and mentors worldwide",
      "Show your performance, rankings, and verified results",
      "Collaborate through SmartCard-secured trading groups",
      "Trade, learn, and grow in a trust-based environment",
    ],
  },
  {
    image: "/assets/homescreen/producttourimage-5.png",
    title: "Stay Connected — Trade, Learn & Engage Anywhere",
    points: [
      "Use M2T seamlessly across mobile, tablet, and desktop",
      "Get live alerts, videos, and AI-driven notifications 24/7",
      "Post, connect, and share like a verified financial network",
      "One SmartCard identity — access everything, anywhere",
    ],
  },
  {
    image: "/assets/homescreen/producttourimage-6.png",
    title: "SmartCard — Your Verified Market Identity",
    points: [
      "Your official Million2Trillion ID — verified, trusted, and globally recognized",
      "Earn instantly by sharing your SmartCard identity across the M2T ecosystem",
      "Unlock personalized tools, dashboards, and verified business opportunities",
      "Access your market profile, stats, and tier benefits — all in one digital card",
      "Your SmartCard is your virtual passport for global entry into Million2Trillion",
    ],
  },
  {
    image: "/assets/homescreen/producttourimage-7.jpg",
    title: "Learn, Earn & Grow — Your M2T Academy",
    points: [
      "Access live webinars, free courses, and mentorship sessions from verified experts",
      "Book 1-to-1 coaching or join certified training programs across global markets",
      "Earn recognition badges and verified certifications from top institutions",
      "Instructors and mentors can host live classes and monetize their expertise",
      "Your learning journey is integrated with SmartCard — track progress, skills, and achievements",
    ],
  },
  {
    image: "/assets/homescreen/producttourimage-8.jpg",
    title: "Live Trading Community — Chat, Share & Analyze",
    points: [
      "Join verified trader groups and discuss live market setups instantly",
      "Share trade ideas, signals, and chart insights in real time",
      "Collaborate on gold, forex, and crypto trends with experts worldwide",
      "Engage in professional discussions powered by SmartCard verification",
      "Stay connected 24/7 with your trusted M2T trading community",
    ],
  },
];

export default function PlatformTourSlider() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const i = setInterval(() => setIndex((v) => (v + 1) % SLIDES.length), 4000);
    return () => clearInterval(i);
  }, []);

  const slide = SLIDES[index];

  return (
    <section className="w-full bg-[#0B0F19] py-24">
      <div className="mx-auto max-w-6xl px-4">
        {/* Header */}
        <div className="mb-10 max-w-3xl">
          <h2 className="text-2xl font-bold text-white sm:text-3xl lg:text-3xl">
            Platform <span className="text-blue-600">Tour</span>
          </h2>
          <p className="mt-1 text-sm text-gray-400 sm:text-base">
            Explore how Million2Trillion works inside — tools, people, activity,
            and opportunities in one ecosystem.
          </p>
        </div>

        {/* Slider Container */}
        <div className="grid min-h-[350px] items-center gap-10 rounded-3xl border border-white/10 bg-gradient-to-b from-[#121826] to-[#0B0F19] p-8 shadow-[0_30px_80px_rgba(0,0,0,0.35)] transition-all duration-700 md:grid-cols-2 md:p-12">
          {/* LEFT IMAGE */}
          <div className="flex items-center justify-center">
            <img
              key={slide.image}
              src={slide.image}
              alt={slide.title}
              className="h-[330px] w-auto max-w-full rounded-3xl object-cover transition-all duration-700"
            />
          </div>

          {/* RIGHT TEXT */}
          <div className="flex flex-col justify-center">
            <h3 className="mb-4 text-2xl font-semibold text-white">
              {slide.title}
            </h3>

            <ul className="space-y-3 text-sm text-gray-300">
              {slide.points.map((p, i) => (
                <li key={i} className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-blue-500" />
                  {p}
                </li>
              ))}
            </ul>

            <div className="mt-6 text-xs text-gray-500">
              ● Live preview of platform capabilities
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
